import { useLocation } from "wouter";

export function useNavigate() {
  return useLocation()[1];
}
